import {
  Avatar,
  Grid2,
  Step,
  StepLabel,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  DotColor,
  StatusChange,
} from "../../common-components/StyledComponents";
import { Field, Form, Formik } from "formik";
import parsePhoneNumber from "libphonenumber-js";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import PageStepperDefaultIco from "../../../assets/icons/PageStepperDefaultIco";
import StepperActiveIco from "../../../assets/icons/StepperActiveIco";
import StepperInprogressIco from "../../../assets/icons/StepperInprogressIco";
import { platformBlackLogo } from "../../../utils/logo";
import CommonButton from "../../../component/Button";
import SnackBar from "../../../component/SnackBar";
import {
  CoverSheetGetCall,
  CoverSheetJobDescription,
  CoverSheetJobDescriptionPUTCall,
  CoverSheetPutCall,
  VisaStatusDetails,
} from "../../../redux/action/CoverSheet";
import SkillDeleteDialog from "../../common-components/DeleteDialog";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { CustomizeSpan } from "../../jobs/style";
import { StepperStyle } from "../../matches/quick-match/style";
import AddExperience from "../components/AddExperience";
import ElcDialog from "../components/ElcDialog";
import JobDescription from "../components/JobDescription";
import Application from "./components/Application";
import Confirmation from "./components/Confirmation";
import DialogNotInterested from "./components/DialogNotInterested";
import YourDetails from "./components/YourDetails";
import { CustomDiv, CustomMarkDown } from "../../chat-bot/style";
import html2pdf from "html2pdf.js";
import { GetWhiteLabelAvatar } from "../../common-components/CoverSheetFunction";
import DialogCandidateHub from "../../jobs/jobs-candidate/components/DialogCandidateHub";

export default function Coversheet() {
  const lg = useMediaQuery("(min-width:767px)");
  const query = new URLSearchParams(useLocation().search);
  const coverId = query.get("id");
  const dispatch = useDispatch();
  const coverSheet = useSelector((state) => state.coverSheet.coverSheetGet);
  const view_resume = query.get("view_resume");
  const [roleDataDetails, setRoleDataDetails] = useState({
    jobDescription: {},
  });
  const printableRef = useRef();
  const [customAttachmentData, setCustomAttachmentData] = useState([]);
  const [expandedPanel, setExpandedPanel] = useState(["Basic Information"]);
  const [elcPopup, setElcPopup] = useState({
    open: false,
    loading: false,
    title: "",
    button: "",
    start_date: "",
    end_date: "",
    name: "",
    index: "",
    form: "",
  });
  const [elcExperience, setElcExperience] = useState({
    open: false,
    loading: false,
    position: "",
    company: "",
    button: "Add",
    index: "",
    form: "",
  });
  const [deleteElc, setDeleteElc] = useState({
    open: false,
    loading: false,
    content: "",
    title: "",
    index: "",
    form: "",
  });
  const [deleteReference, setDeleteReference] = useState({
    open: false,
    loading: false,
    content: "",
  });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [notInterestedDialog, setNotInterestedDialog] = useState({
    open: false,
    disabled: false,
    yesLoading: false,
    availableLoading: false,
    notAvailabelLoading: false,
  });

  const coverSheetModifyData = {
    first_name: "",
    middle_name: "",
    last_name: "",
    title: "",
    seniority_level: "",
    available_industry: [
      {
        name: "Mid Level",
      },
      {
        name: "Senior",
      },
      {
        name: "Fresher",
      },
      {
        name: "Junior",
      },
      {
        name: "Executive",
      },
    ],
    is_prior_background_check: [
      {
        name: "Yes",
      },
      {
        name: "No",
      },
    ],
    prior_background_check: "",

    // rate: {
    //   max: "",
    //   min: "",
    //   period: "Hourly",
    //   currency: "",
    // },
    location: "",
    dob: "",
    portfolio: "",
    email: "",
    phone_number: "",
    notice_period: "",
    job_location: "",
    linkedin_url: "",
    willing_to_relocate: false,
    willing_to_be_onsite: false,
    education: "",
    availability_status: null,
    available_education: [
      {
        name: "PHD Degree",
      },
      {
        name: "Master's Degree",
      },
      {
        name: "Bachelor's Degree",
      },
    ],
    certificates: [],
    certificates_value: "",
    languages: [],
    languages_value: "",
    industry: [],
    industry_value: "",
    govt_security_clearance: false,
    dei: false,
    porche: null,
    porche_data: [{ name: "Yes" }, { name: "No" }],
    manager_name: "",
    department: "",
    employment_period: {
      start_date: "",
      end_date: "",
    },

    employment_type: "",
    employment_data: [{ name: "Permanent" }, { name: "Contract" }],
    tax_term: "",
    tax_term_data: [
      { name: "C2C" },
      { name: "1099" },
      { name: "W2 Contract" },
      { name: "W2 Employee" },
    ],
    attachments: [],
    emplopyer_name: "",
    emplopyer_phone: "",
    emplopyer_email: "",
    emplopyer_contact_name: "",
    hour_rate: "",
    contract_hour_rate: "",
    employee_hour_rate: "",
    visa_type: "",
    visa_type_data: [
      // { name: "Citizen" },
      // { name: "Legal Resident" },
      // { name: "Work Permit H1B" },
      // { name: "Work Permit TN" },
      // { name: "EAD - OPT" },
      // { name: "EAD – H4" },
      // { name: "EAD – L2" },
      // { name: "EAD – Legal Resident" },
    ],
    H1B_holder_company_name: "",
    visa_stamped: "",
    visa_stamped_data: [{ name: "Yes" }, { name: "No" }],
    visa_valid_from: "",
    visa_valid_to: "",
    qualifications: [],
    certifications: [],
    licenses: [],
    job_history: [],
    references: [{ name: "", phone: "", email: "" }],
    client_name: "",
    note: "",
    submitted: false,
    pre_screen_question_answers: [],
    attachment: [],
    phone_number_country: "",
    emplopyer_phone_country: "",
    extension_phone: "",
    period: "hourly",
    citizen_status: "",
    resume_upload: [],
    ead_upload: [],
    rtr_upload: [],
    visa_copy_upload: [],
    linkedIn_pdf: [],
    award_letter: [],
    verified_check: false,
  };
  const [coverSheetData, setCoverSheetData] = useState(coverSheetModifyData);
  const [tabValue, setTabValue] = useState(0);
  const [tabData, setTabData] = useState([
    {
      label: "Job Details",
      status: "In Progress",
    },
    {
      label: "Your Details",
      status: "Pending",
    },
    {
      label: "Confirmation",
      status: "Pending",
    },
  ]);
  const [isLoading, setIsLoading] = useState({
    loading: true,
    buttonLoading: false,
    submitLoading: false,
  });

  const processPhoneNumber = (input) => {
    if (!input) {
      return {
        dialCode: {
          name: "United States",
          dialCode: "1",
          countryCode: "us",
          format: "+. (...) ...-....",
        },
        number: "",
      };
    }
    const cleaned = input.replace(/\s/g, "");

    if (!cleaned.startsWith("+")) {
      return {
        dialCode: null,
        number: cleaned.replace(/\D/g, ""),
      };
    }

    const parsed = parsePhoneNumber(cleaned);

    if (parsed?.isValid()) {
      const dialCode = parsed.countryCallingCode;
      const number = parsed.nationalNumber;
      let countryIso = parsed.country?.toLowerCase();
      if (dialCode === "44" && countryIso !== "je") {
        countryIso = "gb";
      }

      const numberLength = number.length;
      let dynamicFormat = "+" + ".".repeat(dialCode.length) + " ";

      if (numberLength <= 5) {
        dynamicFormat += ".".repeat(numberLength);
      } else {
        const groupSize = Math.floor(numberLength / 2);
        dynamicFormat +=
          ".".repeat(groupSize) + "-" + ".".repeat(numberLength - groupSize);
      }
      return {
        dialCode: {
          name: parsed.country,
          dialCode: dialCode,
          countryCode: countryIso,
          format: dynamicFormat,
        },
        number: `${dialCode}${number}`,
      };
    }

    return {
      dialCode: null,
      number: input.replace(/\D/g, ""),
    };
  };

  // The phone input works with the full digit string (dial code + national
  // number), so normalize whatever was stored into that shape.
  const getPhoneDigits = (rawNumber, country) => {
    const { dialCode, number } = processPhoneNumber(rawNumber || "");
    const code = country?.dialCode || dialCode?.dialCode;
    if (!code || !number) return number;
    if (number.startsWith(code) && parsePhoneNumber(`+${number}`)?.isValid()) {
      return number;
    }
    return `${code}${number}`;
  };

  useEffect(() => {
    if (Object.keys(coverSheet).length !== 0) {
      setCoverSheetData((prev) => ({
        ...prev,
        first_name: coverSheet.personal_details.first_name,
        middle_name: coverSheet.personal_details.middle_name,
        last_name: coverSheet.personal_details.last_name,
        title: coverSheet.personal_details.title,
        seniority_level: coverSheet.personal_details.seniority_level,
        prior_background_check:
          coverSheet.personal_details.prior_background_check,
        // rate: {
        //   max: coverSheet.personal_details.rate.max,
        //   min: coverSheet.personal_details.rate.min,
        //   period: "Hourly",
        //   currency: "",
        // },
        availability_status:
          coverSheet.availability_status || "I am available and interested",
        location: coverSheet.personal_details.location,
        dob: coverSheet.personal_details.dob,
        portfolio: coverSheet.personal_details.portfolio,
        email: coverSheet.personal_details.email,
        phone_number: getPhoneDigits(
          coverSheet.personal_details.phone_number,
          coverSheet.personal_details.phone_number_country
        ),
        phone_number_country:
          Object.keys(coverSheet.personal_details.phone_number_country || {})
            .length === 0
            ? processPhoneNumber(coverSheet.personal_details.phone_number)
                .dialCode || null
            : coverSheet.personal_details.phone_number_country,

        notice_period: coverSheet.personal_details?.notice_period,
        job_location: coverSheet.personal_details.job_location,
        linkedin_url: coverSheet.personal_details.linkedin_url,
        willing_to_relocate:
          coverSheet.personal_details.willing_to_relocate === ""
            ? ""
            : coverSheet.personal_details.willing_to_relocate
            ? "Yes"
            : "No",
        willing_to_be_onsite:
          coverSheet.personal_details?.willing_to_be_onsite === ""
            ? ""
            : coverSheet.personal_details?.willing_to_be_onsite
            ? "Yes"
            : "No" || "",
        education: coverSheet.additional_information.education,
        certificates: coverSheet?.additional_information?.certificates?.map(
          (item) => {
            return { content: item, id: "" };
          }
        ),
        languages: coverSheet?.additional_information?.languages.map((item) => {
          return { content: item, id: "" };
        }),
        industry: coverSheet?.additional_information?.industry.map((item) => {
          return { content: item, id: "" };
        }),
        govt_security_clearance:
          coverSheet.additional_information.govt_security_clearance === ""
            ? ""
            : coverSheet.additional_information.govt_security_clearance
            ? "Yes"
            : "No" || "",
        dei: coverSheet.additional_information.dei,
        porche: coverSheet.previous_experience?.porche,

        manager_name: coverSheet.previous_experience?.manager_name,
        department: coverSheet.previous_experience?.department,
        employment_type: coverSheet.previous_experience?.employment_type,
        tax_term: coverSheet.tax_term?.tax_term,
        emplopyer_name: coverSheet.tax_term?.emplopyer_name,
        emplopyer_phone: coverSheet.tax_term?.emplopyer_phone,
        emplopyer_email: coverSheet.tax_term?.emplopyer_email,
        emplopyer_contact_name: coverSheet.tax_term?.emplopyer_contact_name,
        hour_rate: coverSheet.tax_term?.hour_rate,
        contract_hour_rate: coverSheet.tax_term?.contract_hour_rate,
        employee_hour_rate: coverSheet.tax_term?.employee_hour_rate,
        period: coverSheet.tax_term?.period || "hourly",
        visa_type: coverSheet.visa_information?.visa_type,
        visa_stamped: coverSheet.visa_information?.visa_stamped,
        H1B_holder_company_name:
          coverSheet.visa_information?.H1B_holder_company_name,
        visa_valid_from: coverSheet.visa_information?.visa_valid_from,
        visa_valid_to: coverSheet.visa_information?.visa_valid_to,

        qualifications: coverSheet?.elc_table?.qualifications,
        certifications: coverSheet?.elc_table?.certifications,
        licenses: coverSheet?.elc_table?.licenses,
        job_history: coverSheet?.job_history,
        references: coverSheet?.references?.references || [
          { name: "", phone: "", email: "" },
        ],

        client_name: coverSheet?.client_name,
        employment_period: {
          start_date:
            coverSheet.previous_experience?.employment_period?.start_date || "",
          end_date:
            coverSheet.previous_experience?.employment_period?.end_date || "",
        },
        note: coverSheet?.interest_notes,
        submitted: coverSheet?.submitted,
        pre_screen_question_answers: coverSheet?.pre_screen_question_answers,
        emplopyer_phone_country: coverSheet.tax_term?.emplopyer_phone_country,
        extension_phone: coverSheet.tax_term?.extension_phone,
        verified_check: view_resume === "true" ? true : false,
        attachments:
          view_resume === "true"
            ? coverSheet.attachments.map((item) => {
                return {
                  ...item,
                  name: item.file_name,
                  file_name: item.name,
                };
              }) || []
            : [],
      }));
    }
  }, [coverSheet]);

  const fetchCoverSheet = async () => {
    setIsLoading((prev) => ({
      ...prev,
      loading: true,
    }));
    let params = {
      id: coverId,
    };
    let visa_params = {
      match_id: coverId,
    };
    try {
      let data = await dispatch(CoverSheetGetCall(params));
      let getData = await CoverSheetJobDescription(coverId);
      let visaStatus = await VisaStatusDetails(visa_params);
      setRoleDataDetails({
        jobDescription: getData?.data,
      });
      setCoverSheetData((prev) => ({
        ...prev,
        visa_type_data: visaStatus,
      }));
      setIsLoading((prev) => ({
        ...prev,
        loading: false,
      }));
    } catch (error) {
      setIsLoading((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    fetchCoverSheet();
    if (view_resume === "true") {
      setTabValue(2);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index <= 2 ? { ...tab, status: "Completed" } : { ...tab }
        )
      );
    }
  }, []);

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  // const QontoStepIcon = (props) => {
  //   const { active, className, icon } = props;
  //   const index = icon - 1;
  //   const status = tabData[index]?.status;

  //   if (status === "Completed") {
  //     return <StepperActiveIco size={lg ? "28" : "20"} />;
  //   }

  //   if (active || status === "In Progress") {
  //     return <StepperInprogressIco size={lg ? "28" : "20"} />;
  //   }

  //   return <PageStepperDefaultIco size={lg ? "28" : "20"} color={"#D7E3E9"} />;
  // };

  const QontoStepIcon = (props) => {
    const { active, completed, className } = props;
    const index = props.icon - 1;

    if (completed) {
      return <StepperActiveIco size={lg ? "28" : "20"} />;
    }
    if (active) {
      return <StepperInprogressIco size={lg ? "28" : "20"} />;
    } else
      return (
        <PageStepperDefaultIco size={lg ? "28" : "20"} color={"#D7E3E9"} />
      );
  };

  const handleApply = (condition) => {
    if (condition === "apply") {
      setTabValue(1);

      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? { ...tab, status: "Completed" }
            : index === 1
            ? {
                ...tab,
                status: "In Progress",
              }
            : { ...tab, status: "Pending" }
        )
      );
    } else if (condition === "back") {
      setTabValue(0);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 0
            ? {
                ...tab,
                status: "In Progress",
              }
            : { ...tab, status: "Pending" }
        )
      );
    } else if (condition === "last-back") {
      setTabValue(1);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index === 1
            ? { ...tab, status: "In Progress" }
            : index === 2
            ? { ...tab, status: "Pending" }
            : { ...tab }
        )
      );
    } else if (condition === "submit-proceed") {
      setTabValue(2);
      setTabData((prev) =>
        prev.map((tab, index) =>
          index <= 1
            ? { ...tab, status: "Completed" }
            : { ...tab, status: "In Progress" }
        )
      );
    }
  };

  const handleViewJobDescription = () => {
    const data = document.querySelector(".scroll-job-description");
    if (data) {
      data.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  const handleDialogNotInterestedClose = () => {
    setNotInterestedDialog((prev) => ({
      ...prev,
      open: false,
      disabled: false,
      yesLoading: false,
      availableLoading: false,
      notAvailabelLoading: false,
    }));
  };

  const handleNotInterested = () => {
    setNotInterestedDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleChangeAccor = (panel) => (_, isExpanded) => {
    setExpandedPanel((prev) =>
      isExpanded ? [...prev, panel] : prev.filter((p) => p !== panel)
    );
  };

  const yourDetailsBasic = [
    {
      title: "Are you willing to relocate?",
      required: true,
      component: "toggle",
      disabled: view_resume,
      titleName: "willing_to_relocate",
      toggleData: ["Yes", "No"],
      customSize: 12,
      customStyle: {
        borderTop: "1px solid #EAECF0",
        paddingTop: lg ? "1.5rem" : "1rem",
      },
      checkIndex: true,
    },
    {
      title: "Are you willing to be onsite?",
      required: true,
      component: "toggle",
      disabled: view_resume,
      titleName: "willing_to_be_onsite",
      toggleData: ["Yes", "No"],
      customSize: 12,
      customStyle: {
        borderTop: "1px solid #EAECF0",
        paddingTop: lg ? "1.5rem" : "1rem",
      },
      checkIndex: true,
    },
    {
      title: "Do you have Government / Security Classification ?",
      required: true,
      component: "toggle",
      disabled: view_resume,
      titleName: "govt_security_clearance",
      toggleData: ["Yes", "No"],
      customSize: 12,
      customStyle: {
        borderTop: "1px solid #EAECF0",
        paddingTop: lg ? "1.5rem" : "1rem",
      },
      checkIndex: true,
    },
    {
      title: "What is your Tax Term ?",
      required: true,
      component: "toggle",
      disabled: view_resume,
      titleName: "tax_term",
      toggleData: ["W2 Contract", "W2 Employee", "1099", "C2C"],
      customSize: 12,
      customStyle: {
        borderTop: "1px solid #EAECF0",
        paddingTop: lg ? "1.5rem" : "1rem",
      },
      checkIndex: true,
    },
  ];

  const Citizen = [
    {
      title: "What is your Citizenship Status ?",
      required: true,
      component: "toggle",
      disabled: view_resume,
      titleName: "citizen_status",
      toggleData: ["Citizen", "On VISA"],
      customSize: 12,
      customStyle: {
        borderTop: "1px solid #EAECF0",
        paddingTop: lg ? "1.5rem" : "1rem",
      },
      checkIndex: true,
    },
  ];

  const uploadVisaCopy = [
    {
      title: (
        <Fragment>
          Can you upload your Visa Copy ?{" "}
          <CustomizeSpan color={"#079455"}>(Optional)</CustomizeSpan>
        </Fragment>
      ),
      component: "upload",
      titleName: "visa_copy_upload",
      customSize: 12,
      file_name: "Visa Copy",
    },
  ];

  const resumeUpload = [
    {
      title: (
        <Fragment>
          8. Can you upload your Updated Resume ?
          <CustomizeSpan color={"#079455"}>(Optional)</CustomizeSpan>
        </Fragment>
      ),
      component: "upload",
      titleName: "resume_upload",
      customSize: 12,
      single_upload: true,
    },
  ];

  const attachmentUpload = [
    {
      title: (
        <Fragment>
          1. Can you upload your EAD Document ?
          <CustomizeSpan color={"#079455"}>(Optional)</CustomizeSpan>
        </Fragment>
      ),
      component: "upload",
      titleName: "ead_upload",
      customSize: 6,
      uploadCustomSize: 6,
      file_name: "EAD",
    },
    {
      title: (
        <Fragment>
          2. Can you upload your RTR Document ?
          <CustomizeSpan color={"#079455"}>(Optional)</CustomizeSpan>
        </Fragment>
      ),
      component: "upload",
      titleName: "rtr_upload",
      customSize: 6,
      uploadCustomSize: 6,
      file_name: "RTR",
    },

    {
      title: (
        <Fragment>
          3. Can you upload your LinkedIn PDF ?
          <CustomizeSpan color={"#079455"}>(Optional)</CustomizeSpan>
        </Fragment>
      ),
      component: "upload",
      titleName: "linkedIn_pdf",
      customSize: 6,
      uploadCustomSize: 6,
      file_name: "LinkedIn PDF",
    },

    {
      title: (
        <Fragment>
          4. Can you upload your Award/Recommendation Letter ?
          <CustomizeSpan color={"#079455"}>(Optional)</CustomizeSpan>
        </Fragment>
      ),
      component: "upload",
      titleName: "award_letter",
      customSize: 6,
      uploadCustomSize: 6,
      file_name: "Award/Recommendation Letter",
    },
  ];

  const porche = [
    {
      title: `Have you worked in the past with ${coverSheetData?.client_name}?`,
      required: true,
      component: "toggle",
      disabled: view_resume,
      titleName: "porche",
      toggleData: ["Yes", "No"],
      customSize: 12,
      customStyle: {
        borderTop: "1px solid #EAECF0",
        paddingTop: lg ? "1.5rem" : "1rem",
      },
      checkIndex: true,
    },
  ];

  const enterDetails = [
    {
      title: "First Name",
      component: "input",
      disabled: view_resume,
      fontSize: "15px",
      titleName: "first_name",
      placeholderFontSize: "15px",
      placeholder: "Enter your First Name",
      required: true,
    },
    {
      title: "Last Name",
      component: "input",
      fontSize: "15px",
      disabled: view_resume,
      titleName: "last_name",
      placeholderFontSize: "15px",
      placeholder: "Enter your Last Name",
      required: true,
    },
    {
      title: "Client / Job Location",
      component: "input",
      titleName: "job_location",
      fontSize: "15px",
      disabled: view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your location",
      required: true,
    },
    {
      title: "Primary Location",
      component: "input",
      titleName: "location",
      fontSize: "15px",
      disabled: view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your location",
      required: true,
    },

    {
      title: "Primary Email Address",
      component: "input",
      fontSize: "15px",
      titleName: "email",
      disabled: view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your primary email address",
      required: true,
    },
    {
      component: "split-screen",
      data: [
        {
          size: 12,
          title: "Primary Mobile Number",
          component: "phone-number",
          fontSize: "15px",
          titleName: "phone_number",
          country: "phone_number_country",
          disabled: view_resume,
          placeholderFontSize: "15px",
          placeholder: "Enter your primary mobile number",
          required: true,
        },
      ],
    },
    {
      title: "Notice Period (in days)",
      component: "input",
      fontSize: "15px",
      titleName: "notice_period",
      disabled: view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your Notice Period (in days)",
      required: true,
    },
    {
      title: " Day and Month of Birth",
      name: "Oct 30",
      component: "dob_month",
      titleName: "dob",
      disabled: view_resume,
      required: true,
    },
    {
      title: "Job Title",
      component: "input",
      placeholder: "Enter your Job Title",
      disabled: view_resume,
      fontSize: "15px",
      titleName: "title",
      required: true,
    },
    {
      title: "Seniority Level",
      component: "dropDown",
      titleName: "seniority_level",
      disabled: view_resume,
      dropDownData: "available_industry",
      required: true,
    },
    {
      title: "Highest Level of Education",
      disabled: view_resume,
      component: "dropDown",
      titleName: "education",
      dropDownData: "available_education",
      required: true,
    },
  ];

  const primaryData = [
    {
      title: "First Name",
      component: "input",
      disabled: view_resume,
      fontSize: "15px",
      titleName: "first_name",
      placeholderFontSize: "15px",
      placeholder: "Enter your First Name",
      required: true,
    },
    {
      title: "Middle Name",
      component: "input",
      disabled: view_resume,
      fontSize: "15px",
      titleName: "middle_name",
      placeholderFontSize: "15px",
      placeholder: "Enter your Middle Name",
    },
    {
      title: "Last Name",
      component: "input",
      fontSize: "15px",
      disabled: view_resume,
      titleName: "last_name",
      placeholderFontSize: "15px",
      placeholder: "Enter your Last Name",
      required: true,
    },

    {
      title: "Job Title",
      component: "input",
      disabled: view_resume,
      fontSize: "15px",
      titleName: "title",
      required: true,
    },
    {
      title: "Seniority Level",
      component: "dropDown",
      titleName: "seniority_level",
      disabled: view_resume,
      dropDownData: "available_industry",
      required: true,
    },

    {
      title: "Primary Location",
      component: "input",
      titleName: "location",
      fontSize: "15px",
      disabled: view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your location",
      required: true,
    },
    {
      title: " Day and Month of Birth",
      name: "Oct 30",
      component: "dob_month",
      titleName: "dob",
      disabled: view_resume,
      required: true,
    },
    {
      title: "Client / Job Location",
      component: "input",
      titleName: "job_location",
      fontSize: "15px",
      disabled: view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your location",
      required: true,
    },
    {
      title: "Primary Email Address",
      component: "input",
      fontSize: "15px",
      titleName: "email",
      disabled: view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your primary email address",
      required: true,
    },

    {
      component: "split-screen",
      data: [
        {
          size: 12,
          title: "Primary Mobile Number",
          component: "phone-number",
          fontSize: "15px",
          titleName: "phone_number",
          country: "phone_number_country",
          disabled: view_resume,
          placeholderFontSize: "15px",
          placeholder: "Enter your primary mobile number",
          required: true,
        },
      ],
    },

    {
      title: "Notice Period (in days)",
      component: "input",
      fontSize: "15px",
      titleName: "notice_period",
      disabled: view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your Notice Period (in days)",
      required: true,
    },

    {
      title: "Prior Background Check",
      component: "dropDown",
      titleName: "prior_background_check",
      disabled: view_resume,
      dropDownData: "is_prior_background_check",
    },

    {
      title: "Portfolio",
      size: true,
      component: "input-link",
      titleName: "portfolio",
      disabled: view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your portfolio URL",
    },
    {
      title: "LinkedIn",
      size: true,
      component: "input-link-linkedin",
      titleName: "linkedin_url",
      disabled: view_resume,
      placeholderFontSize: "15px",
      placeholder: "Enter your linkedin URL",
    },
    {
      title: "Are you willing to relocate?",
      required: true,
      disabled:
        coverSheet?.personal_details?.willing_to_relocate !== "" || view_resume,
      component: "toggle",
      titleName: "willing_to_relocate",
      toggleData: ["Yes", "No"],
    },
    {
      title: "Are you willing to be onsite?",
      required: true,
      component: "toggle",
      disabled: view_resume,
      titleName: "willing_to_be_onsite",
      toggleData: ["Yes", "No"],
    },
  ];

  const additionalInforamtion = [
    {
      title: "Highest Level of Education",
      disabled: view_resume,
      component: "dropDown",
      titleName: "education",
      dropDownData: "available_education",
      required: true,
    },
    {
      title: "Certificates",
      disabled: view_resume,
      component: "autoComplete",
      titleName: "certificates",
      placeholder: "Enter Certificates",
      inputValue: "certificates_value",
    },
    {
      title: "Industry",
      component: "autoComplete",
      disabled: view_resume,
      titleName: "industry",
      placeholder: "Enter Industry",
      inputValue: "industry_value",
    },
    {
      title: "Languages",
      component: "autoComplete",
      disabled: view_resume,
      titleName: "languages",
      placeholder: "Enter Languages",
      inputValue: "languages_value",
    },

    {
      title: "Do you have Government / Security Classification ?",
      component: "toggle",
      disabled: view_resume,
      titleName: "govt_security_clearance",
      toggleData: ["Yes", "No"],
      required: true,
    },
  ];

  const previousExperience = [
    {
      title: `Have you worked in the past with ${coverSheetData?.client_name}?`,
      component: "dropDown",
      titleName: "porche",
      dropDownData: "porche_data",
      customSize: 8,
      disabled: view_resume,
      required: true,
    },
  ];

  const conditionalExperience = [
    {
      title: "Employment Period",
      titleName: "employment_period",
      component: "calender",
      placeholder: "Select period",
      disabled: view_resume,
      minDate: "2010-01-01",
      maxDate: new Date(),
      required: true,
    },
    {
      title: "Department",
      component: "input",
      fontSize: "15px",
      titleName: "department",
      placeholderFontSize: "15px",
      placeholder: "Enter department",
      disabled: view_resume,
      required: true,
    },

    {
      title: "Type of Employment",
      component: "dropDown",
      titleName: "employment_type",
      dropDownData: "employment_data",
      placeholder: "Select Answer",
      disabled: view_resume,
      required: true,
    },
    {
      title: "Manager Name",
      component: "input",
      fontSize: "15px",
      titleName: "manager_name",
      placeholderFontSize: "15px",
      placeholder: "Enter manager name",
      disabled: view_resume,
      required: true,
    },
  ];

  const tax_term = [
    {
      title: "Tax Term",
      component: "dropDown",
      titleName: "tax_term",
      dropDownData: "tax_term_data",
      placeholder: "Select tax term",
      disabled: view_resume,
      required: true,
    },
  ];

  const conditional_C2C = [
    {
      title: "Employer Name",
      component: "input",
      fontSize: "15px",
      titleName: "emplopyer_name",
      placeholderFontSize: "15px",
      placeholder: "Enter Employer Name",
      disabled: view_resume,
      required: true,
    },
    {
      title: "Hourly Bill Rate",
      component: "hour",
      fontSize: "15px",
      titleName: "hour_rate",
      placeholder: "Enter Hourly rate",
      disabled: view_resume,
      required: true,
    },
    {
      component: "split-screen",
      data: [
        {
          size: 8,
          title: "Employer Phone",
          component: "phone-number",
          fontSize: "15px",
          titleName: "emplopyer_phone",
          placeholderFontSize: "15px",
          country: "emplopyer_phone_country",
          placeholder: "Enter Employer Phone",
          disabled: view_resume,
          required: true,
        },
        {
          size: 4,
          title: "Extension(Opt).",
          component: "input",
          fontSize: "15px",
          titleName: "extension_phone",
          placeholderFontSize: "15px",
          placeholder: "Enter extension",
          disabled: view_resume,
        },
      ],
    },
    {
      title: "Employer Email",
      component: "input",
      fontSize: "15px",
      titleName: "emplopyer_email",
      placeholderFontSize: "15px",
      placeholder: "Enter Email",
      disabled: view_resume,
      required: true,
    },
    {
      title: "Employer Contact Name",
      component: "input",
      fontSize: "15px",
      titleName: "emplopyer_contact_name",
      placeholderFontSize: "15px",
      placeholder: "Enter Contact Name",
      disabled: view_resume,
      required: true,
    },
  ];

  const conditional_w2contract = [
    {
      title: "All Inclusive Hourly Pay Rate",
      component: "hour",
      fontSize: "15px",
      placeholderFontSize: "15px",
      titleName: "contract_hour_rate",
      placeholder: "Enter Hourly rate",
      disabled: view_resume,
      required: true,
    },
  ];

  const conditional_w2employee = [
    {
      title: "All Inclusive Hourly Pay Rate or Annual Salary",
      component: "input-select",
      fontSize: "15px",
      placeholderFontSize: "15px",
      titleName: "employee_hour_rate",
      placeholder: "Enter Hourly rate or Annual Salary",
      disabled: view_resume,
      currencyValue: "period",
      required: true,
      menuItemData: [
        {
          name: "Hour",
          value: "hourly",
        },
        { name: "Annual", value: "annual" },
      ],
    },
  ];

  const visa_status = [
    {
      title: "Visa Type",
      component: "dropDown",
      titleName: "visa_type",
      dropDownData: "visa_type_data",
      placeholder: "Select visa type",
      disabled: view_resume,
      required: true,
    },
  ];

  const conditional_H1B = [
    {
      title: "Current Visa Holder Company name",
      component: "input",
      fontSize: "15px",
      titleName: "H1B_holder_company_name",
      placeholderFontSize: "15px",
      placeholder: "Enter Visa Holder Company Name",
      disabled: view_resume,
      required: true,
    },
    {
      title: "Visa Stamped in Passport",
      component: "dropDown",
      titleName: "visa_stamped",
      dropDownData: "visa_stamped_data",
      placeholder: "Select Visa Stamp",
      disabled: view_resume,
      required: true,
    },
  ];

  const conditional_opt_ead = [
    {
      title: "Visa Valid From",
      titleName: "visa_valid_from",
      component: "single-calender",
      placeholder: "Select date",
      disabled: view_resume,
      required: true,
    },
    {
      title: "Visa Valid To",
      titleName: "visa_valid_to",
      component: "single-calender",
      placeholder: "Select date",
      disabled: view_resume,
      required: true,
    },
  ];

  const handleCloseElc = () => {
    setElcPopup((prev) => ({
      ...prev,
      open: false,
      loading: false,
      title: "",
      button: "",
      start_date: "",
      end_date: "",
      name: "",
      index: "",
      form: "",
    }));
  };

  const handleElcDialog = (label, form) => {
    setElcPopup((prev) => ({
      ...prev,
      open: true,
      loading: false,
      title: label,
      button: "Add",
      start_date: "",
      end_date: "",
      name: "",
      index: "",
      form: form,
    }));
  };

  const handleElcEdit = (title, data, index, form) => {
    setElcPopup((prev) => ({
      ...prev,
      open: true,
      title: title,
      button: "Update",
      start_date: data?.start_date,
      end_date: data?.start_date,
      name: data?.name,
      index: index,
      form: form,
    }));
  };

  const handlELcSubmit = (title, values) => {
    setElcPopup((prev) => ({
      ...prev,
      loading: true,
    }));
    setIsLoading((prev) => ({
      ...prev,
      loading: true,
    }));
    let payload = {
      name: values.school,
      ...(values?.date_of_issue
        ? { start_date: values.date_of_issue }
        : {
            start_date: values.Date_range.start_date,
            end_date: values.Date_range.end_date,
          }),
    };

    if (title === "Add Education") {
      const previous_update = elcPopup.form.values;
      const updatedJobHistory = [...previous_update.qualifications];

      if (
        values.index !== undefined &&
        values.index !== null &&
        values.index !== ""
      ) {
        updatedJobHistory[values.index] = {
          ...updatedJobHistory[values.index],
          ...payload,
        };
      } else {
        updatedJobHistory.push(payload);
      }
      elcPopup.form.setFieldValue("qualifications", updatedJobHistory);
    } else if (title === "Add Licenses") {
      const previous_update = elcPopup.form.values;
      const updatedJobHistory = [...previous_update.licenses];

      if (
        values.index !== undefined &&
        values.index !== null &&
        values.index !== ""
      ) {
        updatedJobHistory[values.index] = {
          ...updatedJobHistory[values.index],
          ...payload,
        };
      } else {
        updatedJobHistory.push(payload);
      }
      elcPopup.form.setFieldValue("licenses", updatedJobHistory);
    } else if (title === "Add Certification") {
      const previous_update = elcPopup.form.values;
      const updatedJobHistory = [...previous_update.certifications];
      if (
        values.index !== undefined &&
        values.index !== null &&
        values.index !== ""
      ) {
        updatedJobHistory[values.index] = {
          ...updatedJobHistory[values.index],
          ...payload,
        };
      } else {
        updatedJobHistory.push(payload);
      }
      elcPopup.form.setFieldValue("certifications", updatedJobHistory);
    }
    setTimeout(() => {
      setSnackbarState({
        open: true,
        message: "updated Successfully",
        severity: "success",
      });
      handleCloseElc();
      setTimeout(() => {
        setIsLoading((prev) => ({
          ...prev,
          loading: false,
        }));
      }, 1000);
    }, 1000);
  };

  const handleCloseAddExperience = () => {
    setElcExperience((prev) => ({
      ...prev,
      open: false,
      loading: false,
      position: "",
      company: "",
      button: "",
      index: "",
      form: "",
    }));
  };

  const handlExperienceSubmit = (title, values) => {
    setElcExperience((prev) => ({
      ...prev,
      loading: true,
    }));
    // setIsLoading(true);
    let payload = {
      job_title: values.position,
      company: values.company,
      start_date: values.Date_range.start_date,
      end_date: values.Date_range.end_date,
    };
    const previous_elcExperience = elcExperience.form.values;
    const updatedJobHistory = [...previous_elcExperience.job_history];
    if (
      values.index !== undefined &&
      values.index !== null &&
      values.index !== ""
    ) {
      updatedJobHistory[values.index] = {
        ...updatedJobHistory[values.index],
        ...payload,
      };
    } else {
      updatedJobHistory.push(payload);
    }
    elcExperience.form.setFieldValue("job_history", updatedJobHistory);

    setTimeout(() => {
      setSnackbarState({
        open: true,
        message: "updated Successfully",
        severity: "success",
      });
      handleCloseAddExperience();
      // setTimeout(() => {
      //   setIsLoading(false);
      // }, 1000);
    }, 1000);
  };
  const handleDeleteElcClose = () => {
    setDeleteElc((prev) => ({
      ...prev,
      open: false,
      loading: false,
      content: "",
      title: "",
      index: "",
      form: "",
    }));
  };

  const handleDeleteELC = (title, data, index, form) => {
    setDeleteElc((prev) => ({
      ...prev,
      open: true,
      loading: false,
      index: index,
      title: title,
      content: data.name,
      form: form,
    }));
  };
  const handleDeleteElc = () => {
    setDeleteElc((prev) => ({
      ...prev,
      loading: true,
    }));
    // setIsLoading(true);
    const previous_elcdelete = deleteElc.form.values;

    if (deleteElc.title === "Add Education") {
      const updatedDelete = [...previous_elcdelete.qualifications];
      const updatedQualifications = updatedDelete.filter(
        (_, index) => index != deleteElc.index
      );
      deleteElc.form.setFieldValue("qualifications", updatedQualifications);
    } else if (deleteElc.title === "Add Licenses") {
      const updatedDelete = [...previous_elcdelete.licenses];
      const updatedQualifications = updatedDelete.filter(
        (_, index) => index != deleteElc.index
      );
      deleteElc.form.setFieldValue("licenses", updatedQualifications);
    } else if (deleteElc.title === "Add Certification") {
      const updatedDelete = [...previous_elcdelete.certifications];
      const updatedQualifications = updatedDelete.filter(
        (_, index) => index != deleteElc.index
      );
      deleteElc.form.setFieldValue("certifications", updatedQualifications);
    } else if (deleteElc.title === "Add Experience") {
      const updatedDelete = [...previous_elcdelete.job_history];
      const updatedQualifications = updatedDelete.filter(
        (_, index) => index != deleteElc.index
      );
      deleteElc.form.setFieldValue("job_history", updatedQualifications);
    } else if (deleteElc.title === "Attachment") {
      const updatedDelete = [...previous_elcdelete.attachment];
      const updatedQualifications = updatedDelete.filter(
        (_, index) => index != deleteElc.index
      );
      deleteElc.form.setFieldValue("attachment", updatedQualifications);
    }
    setTimeout(() => {
      setSnackbarState({
        open: true,
        message: "Delete Successfully",
        severity: "success",
      });
      handleDeleteElcClose();
      // setTimeout(() => {
      //   setIsLoading(false);
      // }, 1000);
    }, 1000);
  };

  const handleExperienceEdit = (data, index, form) => {
    setElcExperience((prev) => ({
      ...prev,
      open: true,
      button: "Update",
      start_date: data?.start_date,
      end_date: data?.end_date,
      position: data?.job_title,
      company: data?.company,
      index: index,
      form: form,
    }));
  };
  const handleExperienceDelete = (title, data, index, form) => {
    setDeleteElc((prev) => ({
      ...prev,
      open: true,
      loading: false,
      index: index,
      title: title,
      content: data.job_title,
      form: form,
    }));
  };

  const handleScrollToError = (error) => {
    setExpandedPanel((prev) => {
      const newPanels = new Set(prev);

      if (tabValue === 1) {
        if (
          error.willing_to_relocate ||
          error.willing_to_be_onsite ||
          error.govt_security_clearance ||
          error.tax_term ||
          error.emplopyer_name ||
          error.emplopyer_phone ||
          error.extension_phone ||
          error.emplopyer_email ||
          error.emplopyer_contact_name ||
          error.hour_rate ||
          error.contract_hour_rate ||
          error.employee_hour_rate ||
          error.visa_type ||
          error.visa_valid_from ||
          error.visa_valid_to ||
          error.H1B_holder_company_name ||
          error.visa_stamped ||
          error.porche ||
          error.manager_name ||
          error.department ||
          error.employment_period ||
          error.employment_type ||
          error.citizen_status ||
          error.title ||
          error.seniority_level ||
          error.dob ||
          error.phone_number ||
          error.notice_period
        ) {
          newPanels.add("Basic Information");
        } else if (error.pre_screen_question_answers) {
          newPanels.add("Pre-Screen Questions");
        }
      } else {
        if (
          error.first_name ||
          error.last_name ||
          error.title ||
          error.seniority_level ||
          // error.rate?.min ||
          // error.rate?.max ||
          error.dob ||
          error.location ||
          error.job_location ||
          error.email ||
          error.phone_number ||
          error.notice_period ||
          error.linkedin_url
        ) {
          newPanels.add("Primary Information");
        } else if (error.education || error.industry || error.languages) {
          newPanels.add("Additional Information");
        } else if (
          error.porche ||
          error.manager_name ||
          error.department ||
          error.employment_period ||
          error.employment_type
        ) {
          newPanels.add("Previous Experience With The Client");
        } else if (
          error.tax_term ||
          error.emplopyer_name ||
          error.emplopyer_phone ||
          error.extension_phone ||
          error.emplopyer_email ||
          error.emplopyer_contact_name ||
          error.hour_rate ||
          error.contract_hour_rate ||
          error.employee_hour_rate
        ) {
          newPanels.add("Engage");
        } else if (
          error.visa_type ||
          error.visa_valid_from ||
          error.visa_valid_to ||
          error.H1B_holder_company_name ||
          error.visa_stamped
        ) {
          newPanels.add("Visa Status");
        } else if (error.references) {
          newPanels.add("References");
        } else if (error.pre_screen_question_answers) {
          newPanels.add("Pre-Screen Questions");
        }
      }
      return Array.from(newPanels);
    });

    setTimeout(() => {
      const errorElement = document.querySelector(".Mui-error");
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 0);
  };

  const handleAddReference = (name, form) => {
    const updated = [
      ...form.values.references,
      { name: "", phone: "", email: "" },
    ];
    form.setFieldValue(name, updated);
  };

  const handleDeleteClose = () => {
    setDeleteReference((prev) => ({
      ...prev,
      open: false,
      loading: false,
    }));
  };

  const handleDeleteReference = (form, name) => {
    setDeleteReference((prev) => ({
      ...prev,
      loading: true,
    }));
    setTimeout(() => {
      const updated = form.values[name].filter(
        (_, i) => i !== deleteReference.index
      );
      form.setFieldValue(name, updated);
      handleDeleteClose();
    }, 1000);
  };

  const handleDeleteReferenceClick = (item, index) => {
    setDeleteReference((prev) => ({
      ...prev,
      open: true,
      content: item,
      index: index,
    }));
  };

  const validationSchema = Yup.object({
    ...(tabValue === 2
      ? {
          verified_check: Yup.boolean()
            .oneOf([true], "You must verify before proceeding")
            .required("Verification is required"),
        }
      : {}),
    willing_to_relocate: Yup.string().required("Relocate is required"),
    willing_to_be_onsite: Yup.string().required("Onsite is required"),
    citizen_status: Yup.string().required("Citizen Status is required"),
    govt_security_clearance: Yup.string().required("Government is required"),
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    title: Yup.string().required("Job Title is required"),
    seniority_level: Yup.string().required("Seniority Level is required"),
    references: Yup.array().of(
      Yup.object({
        name: Yup.string()
          .trim()
          .nullable()
          .test(
            "name-valid",
            "Reference name must be at least 2 characters",
            (value) => !value || value.length >= 2
          ),

        phone: Yup.string()
          .nullable()
          .test(
            "phone-valid",
            "Phone number must be 10 digits",
            (value) => !value || /^[0-9]{10}$/.test(value)
          ),

        email: Yup.string()
          .nullable()
          .test(
            "email-valid",
            "Invalid email address",
            (value) => !value || Yup.string().email().isValidSync(value)
          ),
      })
    ),
    location: Yup.string().required("Location is required"),
    dob: Yup.string()
      .matches(/^\d{2} [A-Za-z]{3}$/, "Invalid date format")
      .required("Date and Month of Birth is required"),
    job_location: Yup.string().required("Job Location is required"),
    email: Yup.string()
      .required("Email is required")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Invalid email address"
      ),
    phone_number: Yup.string()
      .required("Phone number is required")
      .test(
        "is-valid-phone",
        "Phone number is not valid for the selected country",
        function (value) {
          const { phone_number_country } = this.parent;
          if (!value) return false;
          if (!phone_number_country?.countryCode) {
            return this.createError({ message: "Code is required" });
          }
          let rawDigits = value.toString().replace(/\D/g, "");
          if (
            phone_number_country?.dialCode &&
            rawDigits.startsWith(phone_number_country.dialCode)
          ) {
            rawDigits = rawDigits.slice(phone_number_country.dialCode.length);
          }
          const formattedValue = `+${phone_number_country?.dialCode}${rawDigits}`;
          const phoneNumber = parsePhoneNumber(
            formattedValue,
            phone_number_country.countryCode.toUpperCase()
          );
          return phoneNumber?.isValid();
        }
      ),
    notice_period: Yup.number()
      .typeError("Notice Period must be a number")
      .required("Notice Period is required")
      .min(0, "Notice Period cannot be negative"),

    education: Yup.string().required("Education is required"),

    // industry: Yup.array()
    //   .min(1, "Please enter at least one option")
    //   .required("This field is required"),
    // languages: Yup.array()
    //   .min(1, "Please enter at least one option")
    //   .required("This field is required"),

    porche: Yup.string()
      .oneOf(["Yes", "No"], "Porche must be Yes or No")
      .test("required", function (value) {
        const { client_name } = this.parent;
        if (!value) {
          return this.createError({
            message: `Previous Experience is required`,
          });
        }
        return true;
      }),
    manager_name: Yup.string().when("porche", {
      is: (value) => value === "Yes",
      then: (schema) => schema.required("Manager Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    department: Yup.string().when("porche", {
      is: (value) => value === "Yes",
      then: (schema) => schema.required("Department is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    employment_type: Yup.string().when("porche", {
      is: (value) => value === "Yes",
      then: (schema) => schema.required("Employment Type is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    tax_term: Yup.string()
      .required("Tax Term is required")
      .oneOf(
        ["C2C", "1099", "W2 Contract", "W2 Employee"],
        "Tax Term must be C2C or 1099 or W2 Contract or W2 Employee"
      ),

    emplopyer_name: Yup.string().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) => schema.required("Employer Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    emplopyer_phone: Yup.string().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) =>
        schema
          .required("Phone number is required")
          .test(
            "is-valid-phone",
            "Phone number is not valid for the selected country",
            function (value) {
              const { emplopyer_phone_country } = this.parent;
              if (!value || !emplopyer_phone_country?.countryCode) return false;
              const formattedValue = value.startsWith("+")
                ? value
                : `+${value}`;
              const phoneNumber = parsePhoneNumber(
                formattedValue,
                emplopyer_phone_country.countryCode
              );
              return phoneNumber?.isValid();
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    extension_phone: Yup.string().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) =>
        schema.matches(/^\d+$/, "Extension must contain only numbers"),
      otherwise: (schema) => schema.notRequired(),
    }),
    emplopyer_email: Yup.string().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) =>
        schema
          .required("Employer Email is required")
          .matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            "Invalid Employer email address"
          ),

      otherwise: (schema) => schema.notRequired(),
    }),
    emplopyer_contact_name: Yup.string().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) => schema.required("Employer Contact Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    hour_rate: Yup.number().when("tax_term", {
      is: (value) => value === "C2C" || value === "1099",
      then: (schema) =>
        schema
          .typeError("Hour Rate must be a number")
          .required("Hour Rate is required")
          .min(0, "Hour Rate cannot be negative"),
      otherwise: (schema) => schema.notRequired(),
    }),
    contract_hour_rate: Yup.number().when("tax_term", {
      is: (value) => value === "W2 Contract",
      then: (schema) =>
        schema
          .typeError("Hour Rate must be a number")
          .required("Hour Rate is required")
          .min(0, "Hour Rate cannot be negative"),
      otherwise: (schema) => schema.notRequired(),
    }),
    employee_hour_rate: Yup.number().when("tax_term", {
      is: (value) => value === "W2 Employee",
      then: (schema) =>
        schema
          .typeError("Hourly rate or Annual Salary must be a number")
          .required("Hourly rate or Annual Salary is required")
          .min(0, "Hourly rate or Annual Salary cannot be negative"),
      otherwise: (schema) => schema.notRequired(),
    }),

    visa_type: Yup.string()
      .required("Visa Type is required")
      .oneOf(
        [
          "EAD-OPT",
          "EAD-H4",
          "EAD-L2",
          "H1B Transfer",
          "Work Permit H1B",
          "Work Permit TN",
          "EAD-Legal Resident",
          "Citizen",
          "Legal Resident",
        ],
        "Visa Type must be EAD-OPT or EAD-H4 or EAD-L2 or Work Permit H1B or H1B Transfer or Work Permit TN or EAD-Legal Resident"
      ),

    visa_valid_from: Yup.string().when("visa_type", {
      is: (value) =>
        value === "EAD-OPT" ||
        value === "EAD-H4" ||
        value === "EAD-L2" ||
        value === "Work Permit H1B" ||
        value === "H1B Transfer" ||
        value === "Work Permit TN" ||
        value === "EAD-Legal Resident",
      then: (schema) => schema.required("Date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    visa_valid_to: Yup.string().when("visa_type", {
      is: (value) =>
        value === "EAD-OPT" ||
        value === "EAD-H4" ||
        value === "EAD-L2" ||
        value === "Work Permit H1B" ||
        value === "H1B Transfer" ||
        value === "Work Permit TN" ||
        value === "EAD-Legal Resident",
      then: (schema) =>
        schema
          .required("To date is required")
          .test(
            "is-greater-than-from",
            "To date must be greater than From date",
            function (value) {
              const { visa_valid_from } = this.parent;
              if (!visa_valid_from || !value) return true;
              return new Date(value) > new Date(visa_valid_from);
            }
          ),
      otherwise: (schema) => schema.notRequired(),
    }),
    H1B_holder_company_name: Yup.string().when("visa_type", {
      is: (value) =>
        value === "H1B" ||
        value === "Work Permit H1B" ||
        value === "H1B Transfer" ||
        value === "Work Permit TN" ||
        value === "EAD-Legal Resident",
      then: (schema) => schema.required("Company Name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    visa_stamped: Yup.string().when("visa_type", {
      is: (value) =>
        value === "H1B" ||
        value === "Work Permit H1B" ||
        value === "H1B Transfer" ||
        value === "Work Permit TN" ||
        value === "EAD-Legal Resident",
      then: (schema) => schema.required("Visa Stamp is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    employment_period: Yup.mixed().when("porche", {
      is: (value) => value === "Yes",
      then: (schema) =>
        Yup.object()
          .nullable()
          .test("validate-employment-period", function (value) {
            if (!value?.start_date || !value?.end_date) {
              return this.createError({
                message: "Start Date and End Date are required",
              });
            }

            if (value.start_date === value.end_date) {
              return this.createError({
                message: "Start date and End date cannot be the same",
              });
            }

            return true;
          }),
      otherwise: (schema) => schema.notRequired(),
    }),

    pre_screen_question_answers: Yup.array().of(
      Yup.object().shape({
        answer: Yup.string().required("This field is required"),
      })
    ),
  });

  const handleSubmit = async (values) => {
    setIsLoading((prev) => ({
      ...prev,
      submitLoading: true,
    }));
    setExpandedPanel([
      "Primary Information",
      "Additional Information",
      "Previous Experience With The Client",
      "Tax Information",
      "Citizenship Information",
      "Experience",
      "Education",
      "Certifications",
      "Licences",
      "References",
      "Visa Status",
      "Engage",
      "Pre-Screen Questions",
      "Attachments",
    ]);
    setTimeout(async () => {
      let payload = {
        ...coverSheet,
        availability_status: "I am available and interested",
        personal_details: {
          ...coverSheet.personal_details,
          email: values.email,
          title: values.title,
          location: values.location,
          other_info: {
            interests: "",
            activities: "",
            volunteer_work: "",
          },
          linkedin_url: values.linkedin_url,
          phone_number: values.phone_number
            ? `+${values.phone_number.replace(/\D/g, "")}`
            : "",
          phone_number_country: values.phone_number_country,
          notice_period: values.notice_period,
          seniority_level: values.seniority_level,
          willing_to_relocate:
            values.willing_to_relocate === true ? "Yes" : "No",
          willing_to_be_onsite:
            values.willing_to_be_onsite === "Yes" ? true : false,
          first_name: values.first_name,
          middle_name: values.middle_name,
          last_name: values.last_name,
          portfolio: values.portfolio,
          dob: values.dob,
          job_location: values.job_location,
          prior_background_check: values.prior_background_check,
        },
        additional_information: {
          industry: values.industry?.map((item) => item?.content),
          certificates: values.certificates?.map((item) => item?.content),
          languages: values.languages?.map((item) => item?.content),
          education: values.education,
          govt_security_clearance:
            values.govt_security_clearance === "Yes" ? true : false,
          dei: values.dei,
        },
        elc_table: {
          licenses: values.licenses,
          certifications: values.certifications,
          qualifications: values.qualifications,
          research_paper: [],
        },
        job_history: values.job_history,
        references: {
          references: values.references,
        },
        previous_experience: {
          porche: values.porche,
          ...(values.porche === "Yes"
            ? {
                // employment_period: values.employment_period,
                employment_period: {
                  start_date: values.employment_period.start_date,
                  end_date: values.employment_period.end_date,
                },
                department: values.department,
                employment_type: values.employment_type,
                manager_name: values.manager_name,
              }
            : {}),
        },
        tax_term: {
          tax_term: values.tax_term,
          ...(values.tax_term === "W2 Contract"
            ? { contract_hour_rate: values.contract_hour_rate }
            : values.tax_term === "W2 Employee"
            ? {
                employee_hour_rate: values.employee_hour_rate,
                period: values.period,
              }
            : {
                emplopyer_name: values.emplopyer_name,
                emplopyer_phone: values.emplopyer_phone,
                emplopyer_phone_country: values.emplopyer_phone_country,
                extension_phone: values.extension_phone,
                emplopyer_email: values.emplopyer_email,
                hour_rate: values.hour_rate,
                emplopyer_contact_name: values.emplopyer_contact_name,
              }),
        },
        visa_information: {
          visa_type: values.visa_type,
          ...(values.visa_type === "Work Permit H1B" ||
          values.visa_type === "H1B Transfer" ||
          values.visa_type === "EAD-OPT" ||
          values.visa_type === "EAD-H4" ||
          values.visa_type === "Work Permit TN" ||
          values.visa_type === "EAD-L2" ||
          values.visa_type === "EAD-Legal Resident"
            ? {
                visa_valid_from: values.visa_valid_from,
                visa_valid_to: values.visa_valid_to,
              }
            : {}),
          ...(values.visa_type === "Work Permit H1B" ||
          values.visa_type === "H1B Transfer" ||
          values.visa_type === "Work Permit TN" ||
          values.visa_type === "EAD-Legal Resident"
            ? {
                visa_stamped: values.visa_stamped,
                H1B_holder_company_name: values.H1B_holder_company_name,
              }
            : {}),
        },
        attachments: customAttachmentData,
        pre_screen_question_answers: values.pre_screen_question_answers,
      };

      const element = printableRef.current;
      if (!element) throw new Error("Printable element not found");

      const width = element.offsetWidth;
      const height = element.offsetHeight;

      function isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      }

      function fixSafariUnsupportedColors(container) {
        if (!isSafari()) return;

        const elements = container.querySelectorAll("*");
        elements.forEach((el) => {
          const color = getComputedStyle(el).color;
          if (color.includes("color(")) {
            el.style.color = "rgb(0, 0, 0)";
          }
        });
      }

      fixSafariUnsupportedColors(element);

      const options = {
        margin: [20, 20, 20, 20],
        filename: "Coversheet.pdf",
        image: { type: "jpeg", quality: 2 },
        html2canvas: { scale: 3 },
        jsPDF: {
          unit: "px",
          format: [width + 250, height + 100],
          orientation: "portrait",
        },
      };

      const pdfBlob = await html2pdf()
        .set({ ...options, output: "blob" })
        .from(element)
        .outputPdf("blob");
      const formData = new FormData();
      customAttachmentData.forEach((fileObj) => {
        const file = fileObj.file?.[0]?.file || fileObj.file?.[0];
        if (!file) return;
        const newFileName = `${fileObj.name}_${fileObj.filename}`;
        formData.append("files", file, newFileName);
      });
      formData.append("data", JSON.stringify(payload));
      const now = new Date();
      const datePart = now.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      let hours = now.getHours();
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12 || 12;
      const timePart = `${hours}:${minutes}${ampm}`;
      const fileName = `Coversheet_${datePart}_${timePart}.pdf`;
      formData.append("coversheet_file", pdfBlob, fileName);

      let params = {
        status: "Completed",
      };
      setIsLoading((prev) => ({
        ...prev,
        loading: true,
      }));
      try {
        const data = await CoverSheetPutCall(params, formData);
        await fetchCoverSheet();

        setSnackbarState({
          open: true,
          message: data?.message,
          severity: "success",
        });
        setIsLoading((prev) => ({
          ...prev,
          submitLoading: false,
          loading: false,
        }));
      } catch (error) {
        setSnackbarState({
          open: true,
          message: error.message,
          severity: "error",
        });
        setIsLoading((prev) => ({
          ...prev,
          submitLoading: false,
          loading: false,
        }));
      }
    }, 1000);
  };

  const handleApplyJob = async (condition) => {
    let params = {
      status: condition,
    };
    setNotInterestedDialog((prev) => ({
      ...prev,
      disabled: true,
      yesLoading: condition === "I am not available" ? true : false,
      notAvailabelLoading:
        condition === "I am available but not interested" ? true : false,
      availableLoading:
        condition === "I am unavailable but lets keep in touch" ? true : false,
    }));
    try {
      let data = await CoverSheetJobDescriptionPUTCall(coverId, params);
      fetchCoverSheet();
      handleDialogNotInterestedClose();
      setSnackbarState({
        open: true,
        message: data?.message,
        severity: "success",
      });
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setNotInterestedDialog((prev) => ({
        ...prev,
        disabled: false,
        yesLoading: false,
        notAvailabelLoading: false,
        availableLoading: false,
      }));
    }
  };
  // const handleDownloadPDF = async () => {
  //   setExpandedPanel([
  //     "Primary Information",
  //     "Additional Information",
  //     "Previous Experience With The Client",
  //     "Experience",
  //     "Education",
  //     "Certifications",
  //     "Licences",
  //     "References",
  //     "Visa Status",
  //     "Engage",
  //     "Pre-Screen Questions",
  //   ]);
  //   setSubmitLoading(true);

  //   setTimeout(async () => {
  //     const element = printableRef.current;
  //     const width = element.offsetWidth;
  //     const height = element.offsetHeight;
  //     const options = {
  //       margin: [20, 20, 20, 20],
  //       filename: "Coversheet.pdf",
  //       image: { type: "jpeg", quality: 2 },
  //       html2canvas: { scale: 3 },
  //       jsPDF: {
  //         unit: "px",
  //         format: [width + 250, height + 100],
  //         orientation: "portrait",
  //       },
  //     };

  //     try {
  //       await html2pdf().set(options).from(element).save();
  //     } catch (error) {
  //       console.error("Error generating PDF:", error);
  //     } finally {
  //       setSubmitLoading(false);
  //     }
  //   }, 1000);
  // };

  console.log(
    view_resume === "true" ? true : !coverSheet?.submitted ? true : false,
    "sfsjkfnsjkfnsjkfjn"
  );

  const handleAnotherFunction = () => {
    setExpandedPanel((prev) => {
      if (prev.includes("Attachments")) {
        return prev;
      }
      return [...prev, "Attachments"];
    });
    const data = document.querySelector("#Attachments");
    if (data) {
      data.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  console.log(expandedPanel, "sfkjnsfjknskfjkknj");
  const [descriptionLoading, setDescriptionLoading] = useState({
    loading: false,
    disabled: false,
    open: false,
  });
  const handleDescriptionClose = () => {
    setDescriptionLoading((prev) => ({
      ...prev,
      open: false,
    }));
  };
  const handleDescriptionOpen = () => {
    setDescriptionLoading((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const conditionCheck =
    view_resume === "true" ? true : !coverSheet?.submitted ? true : false;
  return (
    <Fragment>
      <CustomDiv ref={printableRef}>
        {(tabValue === 0 || coverSheet?.submitted) &&
          view_resume !== "true" && (
            <Application
              lg={lg}
              isLoading={isLoading}
              tabValue={tabValue}
              handleViewJobDescription={handleViewJobDescription}
              handleApply={handleApply}
              handleNotInterested={handleNotInterested}
              coverSheet={coverSheet}
            />
          )}

        {conditionCheck && (
          <Formik
            enableReinitialize={true}
            initialValues={coverSheetData}
            validationSchema={validationSchema}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              setFieldValue,
              validateForm,
              setTouched,
            }) => {
              const previous_experience_with_client = [...previousExperience];
              const previous_tax_term = [...tax_term];
              const previous_conditional_w2contract = [
                ...conditional_w2contract,
              ];
              const previous_conditional_w2employee = [
                ...conditional_w2employee,
              ];
              const previous_visa_status = [...visa_status];
              const previous_conditional_H1B = [...conditional_H1B];
              const previous_conditional_opt_ead = [...conditional_opt_ead];
              const previous_yourDetailsBasic = [
                ...yourDetailsBasic,
                ...Citizen,
                ...porche,
              ];

              if (tabValue === 2) {
                if (values.porche === "Yes") {
                  previous_experience_with_client.push(
                    ...conditionalExperience
                  );
                }
                if (values.tax_term === "C2C" || values.tax_term === "1099") {
                  previous_tax_term.push(...conditional_C2C);
                }
                if (values.tax_term === "W2 Contract") {
                  previous_tax_term.push(...previous_conditional_w2contract);
                }
                if (values.tax_term === "W2 Employee") {
                  previous_tax_term.push(...previous_conditional_w2employee);
                }
                if (
                  values.visa_type === "Work Permit H1B" ||
                  values.visa_type === "H1B Transfer" ||
                  values.visa_type === "Work Permit TN" ||
                  values.visa_type === "EAD-Legal Resident"
                ) {
                  previous_visa_status.push(...previous_conditional_H1B);
                }
                if (
                  values.visa_type === "EAD-OPT" ||
                  values.visa_type === "EAD-H4" ||
                  values.visa_type === "EAD-L2" ||
                  values.visa_type === "Work Permit H1B" ||
                  values.visa_type === "H1B Transfer" ||
                  values.visa_type === "Work Permit TN" ||
                  values.visa_type === "EAD-Legal Resident"
                ) {
                  previous_visa_status.push(...previous_conditional_opt_ead);
                }
              } else if (tabValue === 1) {
                if (values.tax_term) {
                  const taxIndex = previous_yourDetailsBasic.findIndex(
                    (item) => item.titleName === "tax_term"
                  );

                  if (values.tax_term === "C2C" || values.tax_term === "1099") {
                    if (taxIndex !== -1) {
                      previous_yourDetailsBasic.splice(
                        taxIndex + 1,
                        0,
                        ...conditional_C2C
                      );
                    }
                  }
                  if (values.tax_term === "W2 Contract") {
                    if (taxIndex !== -1) {
                      previous_yourDetailsBasic.splice(
                        taxIndex + 1,
                        0,
                        ...previous_conditional_w2contract
                      );
                    }
                  }
                  if (values.tax_term === "W2 Employee") {
                    if (taxIndex !== -1) {
                      previous_yourDetailsBasic.splice(
                        taxIndex + 1,
                        0,
                        ...previous_conditional_w2employee
                      );
                    }
                  }
                }
                if (values.porche === "Yes") {
                  const experienceIndex = previous_yourDetailsBasic.findIndex(
                    (item) => item.titleName === "porche"
                  );
                  if (experienceIndex !== -1) {
                    previous_yourDetailsBasic.splice(
                      experienceIndex + 1,
                      0,
                      ...conditionalExperience
                    );
                  }
                }
                if (values.citizen_status === "On VISA") {
                  const citizenIndex = previous_yourDetailsBasic.findIndex(
                    (item) => item.titleName === "citizen_status"
                  );
                  const uploadVisaCopyIndex =
                    previous_yourDetailsBasic.findIndex(
                      (item) => item.titleName === "porche"
                    );
                  if (citizenIndex !== -1) {
                    previous_yourDetailsBasic.splice(
                      citizenIndex + 1,
                      0,
                      ...visa_status
                    );
                  }
                  if (uploadVisaCopyIndex !== -1) {
                    previous_yourDetailsBasic.splice(
                      uploadVisaCopyIndex + 1,
                      0,
                      ...uploadVisaCopy
                    );
                  }
                }

                if (
                  values.visa_type === "Work Permit H1B" ||
                  values.visa_type === "H1B Transfer" ||
                  values.visa_type === "Work Permit TN" ||
                  values.visa_type === "EAD-Legal Resident"
                ) {
                  const visaIndex = previous_yourDetailsBasic.findIndex(
                    (item) => item.titleName === "visa_type"
                  );
                  if (visaIndex !== -1) {
                    previous_yourDetailsBasic.splice(
                      visaIndex + 1,
                      0,
                      ...previous_conditional_H1B
                    );
                  }
                  // previous_visa_status.push(...previous_conditional_H1B);
                }
                if (
                  values.visa_type === "EAD-OPT" ||
                  values.visa_type === "EAD-H4" ||
                  values.visa_type === "EAD-L2" ||
                  values.visa_type === "Work Permit H1B" ||
                  values.visa_type === "H1B Transfer" ||
                  values.visa_type === "Work Permit TN" ||
                  values.visa_type === "EAD-Legal Resident"
                ) {
                  const visaIndex = previous_yourDetailsBasic.findIndex(
                    (item) => item.titleName === "visa_type"
                  );
                  if (visaIndex !== -1) {
                    previous_yourDetailsBasic.splice(
                      visaIndex + 1,
                      0,
                      ...previous_conditional_opt_ead
                    );
                  }
                  previous_visa_status.push(...previous_conditional_opt_ead);
                }
              }

              // const finalArray = enterDetails.filter((item) => {
              //   const value = coverSheetData[item.titleName];
              //   return value === "" || value === null || value === undefined;
              // });

              const finalArray = enterDetails.filter((item) => {
                if (item.component !== "split-screen") {
                  const value = coverSheetData[item.titleName];

                  return value === "" || value === null || value === undefined;
                }

                if (item.component === "split-screen") {
                  const hasEmpty = item.data.some((subItem) => {
                    const value = coverSheetData[subItem.titleName];
                    const isValueEmpty =
                      value === "" || value === null || value === undefined;

                    if (subItem.country) {
                      const countryValue = coverSheetData[subItem.country];
                      return (
                        isValueEmpty || !countryValue?.countryCode
                      );
                    }

                    return isValueEmpty;
                  });

                  return hasEmpty;
                }

                return false;
              });

              const isEmpty = (val) =>
                val === "" ||
                val === null ||
                (Array.isArray(val) && val.length === 0) ||
                val === undefined;

              const isObjectEmpty = (obj) => {
                if (!obj) return true;
                console.log(Object.values(obj).every(isEmpty));
                return Object.values(obj).every(isEmpty);
              };

              const finalBasicDetailsArray = previous_yourDetailsBasic.filter(
                (item) => {
                  if (item.titleName === "employment_period") {
                    return isObjectEmpty(coverSheetData.employment_period);
                  }

                  return isEmpty(coverSheetData[item.titleName]);
                }
              );

              let formikValues = {
                values: values,
                setFieldValue: setFieldValue,
              };

              return (
                <Form
                  // onSubmit={() => {
                  //   handleScrollToError(formErrors);
                  // }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") e.preventDefault();
                  }}
                >
                  <Field>
                    {({ field, form }) => (
                      <Fragment>
                        <CommonGrid2
                          width={{
                            xs: "95%",
                            sm: "90%",
                            md: "80%",
                          }}
                          margin={"auto"}
                          marginTop={
                            lg
                              ? tabValue === 0
                                ? "3rem"
                                : "1rem"
                              : tabValue === 0
                              ? "1.5rem"
                              : "0.5rem"
                          }
                          paddingBottom={!lg && "5rem"}
                        >
                          {tabValue !== 0 && (
                            <Fragment>
                              {coverSheet?.organization?.org_label ||
                              typeof coverSheet?.organization?.org_logo_url ===
                                "string" ? (
                                GetWhiteLabelAvatar(
                                  coverSheet?.organization?.org_logo_url,
                                  coverSheet?.organization?.org_label,
                                  lg
                                )
                              ) : (
                                // <TalairoLogo
                                //   width={lg ? "145px" : "120px"}
                                //   height={"55px"}
                                // />
                                platformBlackLogo({width: lg ? "145px" : "120px", height: "55px"})
                              )}
                            </Fragment>
                          )}
                          <CommonGrid2
                            display={"flex"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                            flexWrap={"wrap"}
                            marginTop={"1rem"}
                          >
                            <Typography
                              variant={lg ? "h2" : "h3"}
                              fontWeight={600}
                              color={"#101828"}
                              width="max-content"
                            >
                              Job Application{" "}
                            </Typography>
                            {(tabValue !== 0 || view_resume === "true") && (
                              <StatusChange
                                padding="5px 10px"
                                fontSize={lg ? "13px" : "11px"}
                              >
                                <DotColor color={"#F7AD00"} />
                                {"In Progress"}
                              </StatusChange>
                            )}
                          </CommonGrid2>

                          <StepperStyle
                            activeStep={tabValue}
                            gap={lg ? "12px" : "8px"}
                            margin={lg ? "2rem  0px 2rem" : "1.5rem 0px 1.5rem"}
                            background="#EBF1F4"
                            borderColor="#D7E3E9"
                            borderRadius={lg ? "10px" : "7px"}
                            padding={lg ? "1rem" : "10px"}
                            marginTop="0px"
                          >
                            {tabData.map((step, index) => (
                              <Step
                                key={step.label}
                                style={{
                                  padding:
                                    index === 2
                                      ? lg
                                        ? "0px 0px 0px 1.2rem"
                                        : "0px 0px 0px 10px"
                                      : index === 0
                                      ? lg
                                        ? "0px 1.2rem 0px 0px"
                                        : "0px 10px 0px 0px"
                                      : lg
                                      ? "0px 1.2rem"
                                      : "0px 10px",
                                }}
                              >
                                <StepLabel StepIconComponent={QontoStepIcon}>
                                  <CommonGrid2
                                    display="flex"
                                    flexDirection="column"
                                    gap="5px"
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                  >
                                    <Typography
                                      variant={lg ? "span" : "subtitle2xs"}
                                      color="#344054"
                                      fontWeight={lg ? 600 : 700}
                                    >
                                      {step.label}
                                    </Typography>

                                    <Typography
                                      fontWeight={lg ? 500 : 600}
                                      variant={lg ? "span" : "subtitle2xs"}
                                      color={
                                        step.status === "Completed"
                                          ? "#17B26A"
                                          : step.status === "In Progress"
                                          ? "#7F56D9"
                                          : "#5B738B"
                                      }
                                    >
                                      {step.status}
                                    </Typography>
                                  </CommonGrid2>
                                </StepLabel>
                              </Step>
                            ))}
                          </StepperStyle>

                          {tabValue === 0 && (
                            <Fragment>
                              <JobDescription
                                loading={isLoading.loading}
                                roleDataDetails={roleDataDetails}
                                lg={lg}
                              />
                              <Typography
                                onClick={handleDescriptionOpen}
                                marginTop={"10px"}
                                color={"#7F56D9"}
                                fontWeight={600}
                                cursor={"pointer"}
                                sx={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  "&:hover": {
                                    color: "#6941C6",
                                  },
                                }}
                              >
                                View Detailed Job Description
                              </Typography>
                              <DialogCandidateHub
                                open={descriptionLoading.open}
                                handleButttonClose={handleDescriptionClose}
                                title={"Job Description"}
                                titlepadding={"0px"}
                                maxWidth={"md"}
                                minWidth={!lg && "95%"}
                                content={
                                  <CustomDiv textAlign={"start"}>
                                    <CustomMarkDown
                                      fontSize={lg ? "14px" : "13px"}
                                    >
                                      {typeof roleDataDetails.jobDescription
                                        ?.detailed_job_text === "string"
                                        ? roleDataDetails.jobDescription?.detailed_job_text.trim()
                                        : JSON.stringify(
                                            roleDataDetails.jobDescription
                                              ?.detailed_job_text
                                          )}
                                    </CustomMarkDown>
                                  </CustomDiv>
                                }
                              />
                            </Fragment>
                          )}
                          {tabValue === 1 && (
                            <Grid2 size={12}>
                              <YourDetails
                                lg={lg}
                                expandedPanel={expandedPanel}
                                loading={isLoading.loading}
                                handleChangeAccor={handleChangeAccor}
                                yourDetailsBasic={finalBasicDetailsArray}
                                handleDeleteReferenceClick={
                                  handleDeleteReferenceClick
                                }
                                handleAddReference={handleAddReference}
                                form={form}
                                view_resume={view_resume}
                                enterDetails={finalArray}
                                coverSheet={coverSheet}
                                attachmentUpload={attachmentUpload}
                              />
                            </Grid2>
                          )}
                          {tabValue === 2 && (
                            <Confirmation
                              handleChangeAccor={handleChangeAccor}
                              primaryData={primaryData}
                              additionalInforamtion={additionalInforamtion}
                              isLoading={isLoading}
                              previous_experience_with_client={
                                previous_experience_with_client
                              }
                              previous_tax_term={previous_tax_term}
                              previous_visa_status={previous_visa_status}
                              handleExperienceEdit={handleExperienceEdit}
                              handleExperienceDelete={handleExperienceDelete}
                              view_resume={view_resume}
                              handleElcEdit={handleElcEdit}
                              handleDeleteELC={handleDeleteELC}
                              expandedPanel={expandedPanel}
                              handleElcDialog={handleElcDialog}
                              handleDeleteReferenceClick={
                                handleDeleteReferenceClick
                              }
                              handleAddReference={handleAddReference}
                              form={form}
                              lg={lg}
                              customAttachmentData={customAttachmentData}
                              setCustomAttachmentData={setCustomAttachmentData}
                              coverSheet={coverSheet}
                              handleAnotherFunction={handleAnotherFunction}
                            />
                          )}

                          <CommonGrid2
                            display={"flex"}
                            gap={"1rem"}
                            margin={lg ? "2rem 0px" : "0px"}
                            customStyle={
                              !lg
                                ? {
                                    position: "fixed",
                                    bottom: "0px",
                                    left: "0px",
                                    width: "100%",
                                    padding: "1rem",
                                    background: "#fff",
                                    boxShadow: "0px -8px 20.7px 0px #7F56D933",
                                    zIndex: 9,
                                  }
                                : {}
                            }
                          >
                            {tabValue === 0 ? (
                              <Fragment>
                                <CommonButton
                                  customStyle={{
                                    maxWidth: lg ? "200px" : "100%",
                                    width: "100%",
                                  }}
                                  variant="outlined"
                                  color="#344054"
                                  width={"100%"}
                                  border={"#D0D5DD"}
                                  mobileFontSize="13px"
                                  fontWeight={700}
                                  value={"Not Interested"}
                                  padding={"10px 1.5rem"}
                                  onClick={handleNotInterested}
                                  disabled={isLoading.loading}
                                />
                                <CommonButton
                                  customStyle={{
                                    maxWidth: lg ? "200px" : "100%",
                                    width: "100%",
                                  }}
                                  mobileFontSize="13px"
                                  fontWeight={700}
                                  value={"Apply Now"}
                                  disabled={isLoading.loading}
                                  onClick={() => handleApply("apply")}
                                  padding={"10px 1.5rem"}
                                />
                              </Fragment>
                            ) : tabValue === 1 ? (
                              <Fragment>
                                <CommonButton
                                  customStyle={{
                                    maxWidth: lg ? "200px" : "100%",
                                    width: "100%",
                                  }}
                                  variant="outlined"
                                  color="#344054"
                                  width={"100%"}
                                  border={"#D0D5DD"}
                                  mobileFontSize="13px"
                                  fontWeight={700}
                                  value={"Back"}
                                  onClick={() => handleApply("back")}
                                  padding={"10px 1.5rem"}
                                  disabled={isLoading.loading}
                                />

                                <CommonButton
                                  customStyle={{
                                    maxWidth: lg ? "200px" : "100%",
                                    width: "100%",
                                  }}
                                  mobileFontSize="13px"
                                  fontWeight={700}
                                  value={"Proceed"}
                                  type="button"
                                  onClick={async () => {
                                    const errors = await validateForm();
                                    if (Object.keys(errors).length > 0) {
                                      setTouched(
                                        Object.keys(errors).reduce(
                                          (acc, key) => ({
                                            ...acc,
                                            [key]: true,
                                          }),
                                          {}
                                        )
                                      );
                                      handleScrollToError(errors);
                                      return;
                                    }
                                    setExpandedPanel([]);
                                    window.scrollTo({
                                      top: 0,
                                      behavior: "smooth",
                                    });
                                    handleApply("submit-proceed");
                                  }}
                                  disabled={isLoading.loading}
                                  padding={"10px 1.5rem"}
                                />
                              </Fragment>
                            ) : (
                              view_resume !== "true" && (
                                <Fragment>
                                  <CommonButton
                                    customStyle={{
                                      maxWidth: lg ? "200px" : "100%",
                                      width: "100%",
                                    }}
                                    variant="outlined"
                                    color="#344054"
                                    width={"100%"}
                                    border={"#D0D5DD"}
                                    mobileFontSize="13px"
                                    fontWeight={700}
                                    value={"Back"}
                                    onClick={() => handleApply("last-back")}
                                    padding={"10px 1.5rem"}
                                    disabled={isLoading.loading}
                                  />
                                  <CommonButton
                                    customStyle={{
                                      maxWidth: lg ? "200px" : "100%",
                                      width: "100%",
                                    }}
                                    type="button"
                                    mobileFontSize="13px"
                                    fontWeight={700}
                                    value={"Submit Application"}
                                    onClick={async () => {
                                      const errors = await validateForm();
                                      if (Object.keys(errors).length > 0) {
                                        setTouched(
                                          Object.keys(errors).reduce(
                                            (acc, key) => ({
                                              ...acc,
                                              [key]: true,
                                            }),
                                            {}
                                          )
                                        );
                                        handleScrollToError(errors);
                                        return;
                                      }
                                      handleSubmit(values);
                                    }}
                                    disabled={isLoading.submitLoading}
                                    loading={isLoading.submitLoading}
                                    padding={"10px 1.5rem"}
                                  />
                                </Fragment>
                              )
                            )}
                          </CommonGrid2>

                          <AddExperience
                            open={elcExperience.open}
                            onClose={handleCloseAddExperience}
                            title={"Add Experience"}
                            handlExperienceSubmit={handlExperienceSubmit}
                            elcExperience={elcExperience}
                          />

                          <ElcDialog
                            open={elcPopup.open}
                            onClose={handleCloseElc}
                            title={elcPopup.title}
                            handlELcSubmit={handlELcSubmit}
                            elcPopup={elcPopup}
                          />
                          <SkillDeleteDialog
                            deleteDialog={deleteElc.open}
                            handleDeleteDialogClose={handleDeleteElcClose}
                            handleDeleteSkill={handleDeleteElc}
                            buttonLoading={deleteElc.loading}
                            title={deleteElc.title.replace("Add", "Delete")}
                            content={deleteElc.content}
                          />

                          <SkillDeleteDialog
                            deleteDialog={deleteReference.open}
                            handleDeleteDialogClose={handleDeleteClose}
                            handleDeleteSkill={() =>
                              handleDeleteReference(form, "references")
                            }
                            buttonLoading={deleteReference.loading}
                            title={"Delete Reference"}
                            content={deleteReference.content?.name}
                          />
                        </CommonGrid2>
                      </Fragment>
                    )}
                  </Field>
                </Form>
              );
            }}
          </Formik>
        )}
      </CustomDiv>
      <DialogNotInterested
        notInterestedDialog={notInterestedDialog}
        open={notInterestedDialog.open}
        handleClose={handleDialogNotInterestedClose}
        lg={lg}
        handleApplyJob={handleApplyJob}
      />
      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </Fragment>
  );
}
